export default __webpack_public_path__ + "static/media/user.dd985f1e.svg";